export default "__VITE_ASSET__4bfab675__"